// extracted by mini-css-extract-plugin
export default {"bloks":"style_bloks__FDjc0","bloksItem":"style_bloksItem__YcW4t","card_image":"style_card_image__Z7Wyp","card_image_id":"style_card_image_id__+fIiS"};